import { z } from "zod/v4";

const suggestion = z.object({ definitionId: z.uuid() }).strict();
export const CalendarDefinitionsResponseSchema = z.object({
  type: z.literal("calendar_definitions"),
  content: z.object({
    metrics: z.array(suggestion).max(20),
    segments: z.array(suggestion).max(20),
  }),
});
